import React from 'react';

import { ChatSettingsProvider, ChatSettingsProviderProps } from '@common/react/components/Chat/ChatSettingsProvider';
import { ChatPlugins, ChatMessage, Chat } from '@common/react/components/Chat/Chat';
import { VideoMessagePlugin } from '@common/react/components/Chat/VideoMessagePlugin/VideoMessagePlugin';
import { VoiceMessagePlugin } from '@common/react/components/Chat/VoiceMessage/VoiceMessagePlugin';
import { TypingPlugin } from '@common/react/components/Chat/TypingPlugin/TypingPlugin';
import { MentionPlugin } from '@common/react/components/Chat/MentionPlugin/MentionPlugin';
import { FilePlugin } from '@common/react/components/Chat/FilesPlugin/FilesPlugin';
import { EmojiPlugin } from '@common/react/components/Chat/EmojiPlugin/EmojiPlugin';
import { ColorboxPlugin } from '@common/react/components/Chat/ColorboxPlugin/ColorboxPlugin';
import { LinkPreviewPlugin } from '@common/react/components/Chat/LinkPreviewPlugin/LinkPreviewPlugin';
import { EmailPlugin } from '@common/react/components/Chat/Email/EmailPlugin';
import { BaseUserWithAvatar } from '@common/typescript/objects/BaseUser';

const ChatSettingsProviderWithMorePlugins = <
	TUser extends BaseUserWithAvatar = BaseUserWithAvatar,
	TChatMessage extends ChatMessage<TUser> = ChatMessage<TUser>,
	TChat extends Chat<TUser> = Chat<TUser>>(props: ChatSettingsProviderProps<TUser, TChatMessage, TChat>) => {
	return <ChatSettingsProvider<TUser, TChatMessage, TChat>
		otherComponents={[ChatPlugins.ColorBox]}
		formTags={[ChatPlugins.VideoMessage, ChatPlugins.VoiceMessage]}
		listComponent={[ChatPlugins.Typing]}
		messageControlWrappers={[ChatPlugins.Typing]}
		messageControl={ChatPlugins.Mentions}
		{...props}
		plugins={{
			[ChatPlugins.VideoMessage]: VideoMessagePlugin,
			[ChatPlugins.VoiceMessage]: VoiceMessagePlugin,
			[ChatPlugins.Typing]: TypingPlugin,
			[ChatPlugins.Mentions]: MentionPlugin,
			[ChatPlugins.Files]: FilePlugin,
			[ChatPlugins.Emoji]: EmojiPlugin,
			[ChatPlugins.ColorBox]: ColorboxPlugin,
			[ChatPlugins.LinkPreview]: LinkPreviewPlugin,
			[ChatPlugins.Email]: EmailPlugin,
			...props.plugins,
		} as any}
	>
		{props.children}
	</ChatSettingsProvider>;
};

export default ChatSettingsProviderWithMorePlugins;
